<template>
  <div class="my_container">
    <div v-if = "!isUserBind" class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Login' }">登录</el-breadcrumb-item>
        <el-breadcrumb-item>微信授权</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-else class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'AccountSecurity' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'AccountSecurity' }">账号管理</el-breadcrumb-item>
        <el-breadcrumb-item>微信授权绑定</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title_top_hr">
      <p>
        <i></i>
        <span v-if = "!isUserBind">微信授权登录</span>
        <span v-else>微信授权绑定</span>
      </p>
      <el-divider></el-divider>
    </div>
    <!-- 第三方登录绑定 -->
    <div class="login_three_box"
      v-if = "!isUserBind"
      v-loading="loading"
      element-loading-text="授权信息获取中..."
      element-loading-spinner="el-icon-loading"
    >
      <!-- 左侧信息展示 -->
      <div class="login_three_info lf">
        <left-view :info="info"></left-view>
      </div>
      <!-- 右侧账号关联 -->
      <div class="login_three_bind lf">
        <div class="rg_form_box">
          <div v-if="active.password || active.tel" class="rg_form_box_title">
            <p class="login_title" :class="{active : active.tel}" @click="navActive('tel')">手机登录</p>
            <p class="login_title" :class="{active : active.password}" @click="navActive('password')">账号登录</p>
          </div>
          <div v-else class="rg_form_box_title">
            <p class="login_title" :class="{active : active.register}">快速注册</p>
          </div>
          <div class="login_three_form">
            <user-view v-if="active.password" :info = 'info' :type="bindType" @active="navActive"></user-view>
            <tel-view v-if="active.tel" :info = 'info' :type="bindType" @active="navActive"></tel-view>
            <register-view v-if="active.register" :info = 'info' :type="bindType" @active="navActive"></register-view>
          </div>
        </div>
      </div>
    </div>
    <!-- 第三方个人中心绑定 -->
    <div v-else class="login_bind_box">
      <div class="login_bind_top">
        <div class="login_bind_info lf">
          <p class="login_bind_title">微信头像、昵称信息</p>
          <div class="login_bind_pic">
            <img v-if="info.headimgurl !== ''" :src="info.headimgurl" alt="微信头像">
            <img v-else src="http://cms.greenglga.com/default.jpg" alt="微信头像">
          </div>
          <p class="login_bind_name">{{info.nickname}}</p>
        </div>
        <div class="login_bind_info rt">
          <p class="login_bind_title">绿盟平台账号信息</p>
          <div class="login_bind_pic">
            <img v-if="loginInfo.portrait !== ''" :src="loginInfo.portrait" alt="平台头像">
            <img v-else src="http://cms.greenglga.com/default.jpg" alt="平台头像">
          </div>
          <p class="login_bind_name">{{loginInfo.name}}</p>
        </div>
        <div class="login_bind_icon">
          <p></p>
          <p></p>
          <p></p>
          <div>
            <i class="my_icon_list bind"></i>
          </div>
          <p></p>
          <p></p>
          <p></p>
        </div>
      </div>
      <div class="login_bind_bottom">
        <p class="lf">请确认是否绑定账号信息</p>
        <div class="login_bind_btn rt">
          <button class="my_follow_btn" @click = "bindClose">取消</button>
          <el-button type="primary" class="my_follow_btn" @click="bind">绑定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftInfo from './relationLeftInfoy.vue' // 左侧信息展示
import userLogin from './relationUserLogin.vue' // 用户名登录关联
import telLogin from './relationTelLogin.vue' // 手机登录关联
import registerLogin from './relationRegister.vue' // 注册关联登录
export default {
  components: {
    leftView: leftInfo,
    userView: userLogin,
    telView: telLogin,
    registerView: registerLogin
  },
  data () {
    return {
      loading: true,
      code: '',
      activeName: 'tel',
      active: {
        password: false,
        tel: true,
        register: false
      },
      info: {
        headimgurl: '',
        nickname: ''
      },
      bindType: 'weixin',
      isUserBind: false, // 监控是否为绑定
      loginInfo: { // 如果已经登录用户的信息
        portrait: '',
        name: ''
      }
    }
  },
  created () {
    // 判断是否为绑定
    if (this.$store.state.user.info === null) {
      this.isUserBind = false
    } else {
      this.isUserBind = true
      this.loginInfo.portrait = this.$store.state.user.info.portrait
      this.loginInfo.name = this.$store.state.user.info.name
    }
    // 获取code
    const url = window.location.toString()
    const arrUrl = url.split('?')
    const para = arrUrl[1]
    this.code = this.getSearchString('code', para)
    if (this.$store.state.user.weixinInfo === null) { // 判断code是否存在
      if (this.isUserBind) { // 是否有账户信息
        this.webWeChatBind(this.code) // 不存在直接调取接口获取微信信息
      } else {
        this.webWeChatLogin(this.code) // 不存在直接调取接口获取微信信息
      }
    } else { // 如果存在(防止页面刷新)
      if (this.$store.state.user.weixinInfo.code === this.code) { // code值与储存的code一致，直接读取信息
        if (this.$store.state.user.weixinInfo.is_login === 1) {
          this.$router.push({ name: 'Home' })
        } else {
          this.loading = false
          this.info = this.$store.state.user.weixinInfo
        }
      } else { // code值与储存的code不一致，调取接口获取微信信息
        if (this.isUserBind) { // 是否有账户信息
          this.webWeChatBind(this.code) // 不存在直接调取接口获取微信信息
        } else {
          this.webWeChatLogin(this.code) // 不存在直接调取接口获取微信信息
        }
      }
    }
  },
  methods: {
    // 导航栏切换
    navActive (text) {
      this.activeName = text
      switch (text) {
        case 'password':
          this.active.password = true
          this.active.tel = false
          this.active.register = false
          break
        case 'tel':
          this.active.password = false
          this.active.tel = true
          this.active.register = false
          break
        case 'register':
          this.active.password = false
          this.active.tel = false
          this.active.register = true
          break
      }
    },
    // 获取地址栏code
    getSearchString (key, search) {
      const str = search
      const arr = str.split('&')
      const obj = {}
      for (let i = 0; i < arr.length; i++) {
        const tmpArr = arr[i].split('=')
        obj[decodeURIComponent(tmpArr[0])] = decodeURIComponent(tmpArr[1])
      }
      return obj[key]
    },
    // 获取微信登录信息
    webWeChatLogin (code) {
      const vueThat = this
      vueThat.myApi.webWeChatLogin({ code: code }).then((res) => {
        if (res.data.code === 200) {
          vueThat.info = res.data.data.data
          vueThat.info.code = vueThat.code
          vueThat.$store.commit('user/updateWeixinInfo', vueThat.info)
          if (vueThat.info.is_login === 1) {
            vueThat.$store.commit('user/updateUserInfo', {
              id: res.data.data.info.user_id,
              name: res.data.data.info.user_name,
              authorization: res.data.data.info.token,
              sig: res.data.data.info.sig,
              is_authentication: res.data.data.info.is_authentication,
              portrait: res.data.data.info.portrait
            })
            vueThat.$message.success('登录成功！')
            // 登录腾讯IM
            vueThat.webIM.login({ userID: res.data.data.info.user_id + '', userSig: res.data.data.info.sig })
              .then(function (imResponse) {
                console.log(imResponse.data) // 登录成功
              }).catch(function (imError) {
                console.warn('login error:', imError) // 登录失败的相关信息
              })
            // 登录成功后的跳转
            if (vueThat.$store.state.other.oldUrl === '') {
              vueThat.$router.push({ name: 'Home' })
            } else {
              vueThat.$router.go(-1)
            }
          } else {
            vueThat.loading = false
          }
        }
      })
    },
    // 页面跳转
    jump (type) {
      let url = ''
      switch (type) {
        case 'userAgreement':
          url = '/userAgreement'
          break
        case 'privacyAgreement':
          url = '/privacyAgreement'
          break
      }
      const routeData = this.$router.resolve({
        path: url
      })
      window.open(routeData.href, '_blank')
    },
    // 获取微信信息
    webWeChatBind (code) {
      const vueThat = this
      const data = {
        code: code,
        type: vueThat.bindType
      }
      vueThat.myApi.tripartiteInfo(data).then(res => {
        if (res.data.code === 200) {
          vueThat.info = res.data.data
          vueThat.info.code = code
          vueThat.$store.commit('user/updateWeixinInfo', vueThat.info)
        }
      })
    },
    // 同意绑定
    bind () {
      const vueThat = this
      const data = {
        type: vueThat.bindType,
        union_id: vueThat.info.union_id
      }
      vueThat.myApi.bingTripartite(data).then(res => {
        if (res.data.code === 200) {
          vueThat.$message.success('绑定成功')
          vueThat.$router.push({ name: 'AccountSecurity' })
        }
      })
    },
    // 取消绑定
    bindClose () {
      this.$router.push({ name: 'AccountSecurity' })
    }
  }
}
</script>

<style>
</style>
